/* eslint-disable @next/next/no-page-custom-font */
import React, { useState, useEffect, useRef } from "react"
import moment from "moment"
import styled from "styled-components"
import { useRouter } from "next/router"

import MetaData from "@/common/components/MetaData"
import ResetCSS from "@/common/assets/css/style"

import KeyVisualNew from "./Views/KeyVisualNew"

import "react-toastify/dist/ReactToastify.css"
import SeriesOfEvents from "./Views/SeriesOfEvents"
import Footer from "./Views/Footer"
import TopNav from "./Views/TopNav"
import Popup from "./Views/Popup"
import Count from "./Views/Count"
import Head from "next/head"
import Rewards from "./Views/Rewards"
import Bonus from "./Views/Bonus"
import BonusSecond from "./Views/BonusSecond"
import Partners from "./Views/Partners"

const LuckyBag2023 = ({ dayS, dayE }) => {
  const [isNavOpen, setNavOpen] = useState(false)
  const [totalSupply, setTotalSupply] = useState(0)
  const [walletConnectModal, setWalletConnectModal] = useState(false)
  const [maxDailyMintAmount, setMaxDailyMintAmount] = useState(1)
  const [mintPeriod, setMintPeriod] = useState()
  const [address, setAddress] = useState("")
  const [loading, setLoading] = useState()
  const [minted, setMinted] = useState()

  const [showPopup, setShowPopup] = useState("close")
  const [popupContent, setPopupContent] = useState()

  const router = useRouter()
  let subscribeTotalSupply = useRef()

  // =====================================獎勵數量這邊調整

  const eventDay1Start = moment().valueOf() > dayS

  const eventEnd = moment().valueOf() > dayE

  const isMintPeriod = () => {
    return moment().valueOf() > dayS && moment().valueOf() < dayE
  }

  useEffect(() => {
    // Check if browser is running Metamask
    if (typeof window.ethereum === "undefined") {
      return
    }

    function handleAccountsChanged(accounts) {
      setAddress(accounts[0])
    }
    ethereum.on("accountsChanged", handleAccountsChanged)

    return function cleanup() {
      ethereum.removeListener("accountsChanged", handleAccountsChanged)
    }
  }, [])

  const onDisconnect = () => {
    if (window.web3 && !window.web3.eth.currentProvider.isMetaMask) {
      window.web3.eth.currentProvider.disconnect()
    }
    window.web3 = null
    window.ethereum = null
    window.localStorage.removeItem("walletconnect")
    window.localStorage.removeItem("metamask")

    setAddress("")
    router.reload(window.location.pathname)
  }

  useEffect(() => {
    if (minted) {
      clearInterval(subscribeTotalSupply.current)
    }
  }, [minted])

  return (
    <>
      <MetaData
        title={`狂歡兒童節！NFT免費領！| Apple大禮包 , PS5 大獎抽抽抽！| KryptoGO x 91 APP`}
        description="3/31~4/7，天天開放 9,999 份 NFT，每個皆含 5 個精選好禮，參加即可抽 iPhone 14、Apple Watch SE、airpod 3、iPad 10、Apple TV 以及 PS5！"
        url={`https://www.kryptogo.com/nft-toy-box`}
        image="https://i.ibb.co/pvsXSJH/BANNER.png"
      />
      <Head>
        <link
          href="https://fonts.googleapis.com/css2?family=Barlow:wght@700&family=Noto+Sans+TC:wght@300;500;700&display=swap"
          rel="stylesheet"
        />
      </Head>
      <ResetCSS />
      <Wrapper>
        <NavbarWrapper>
          <TopNav
            address={address}
            isNavOpen={isNavOpen}
            setWalletConnectModal={setWalletConnectModal}
            setNavOpen={setNavOpen}
            onDisconnect={onDisconnect}
            dayS={dayS}
            dayE={dayE}
          />
        </NavbarWrapper>
        <Popup
          showPopup={showPopup}
          setShowPopup={setShowPopup}
          content={popupContent}
        />

        {/* 主視覺 */}
        <KeyVisualNew
          eventEnd={eventEnd}
          eventDay1Start={eventDay1Start}
          totalSupply={totalSupply}
          maxDailyMintAmount={maxDailyMintAmount}
          minted={minted}
          setMinted={setMinted}
          mintPeriod={mintPeriod}
          loading={loading}
          setLoading={setLoading}
          setMintPeriod={setMintPeriod}
          dayS={dayS}
          dayE={dayE}
          setShowPopup={setShowPopup}
          popupContent={popupContent}
          setPopupContent={setPopupContent}
        />
        {/* 系列活動 */}
        <SeriesOfEvents dayS={dayS} dayE={dayE} />

        <Rewards dayS={dayS} dayE={dayE} />
        {/* BONUS */}
        <Bonus dayS={dayS} dayE={dayE} />
        <BonusSecond />
        {/* 數量 */}
        <Count />
        {/* 和作夥伴*/}
        <Partners dayS={dayS} dayE={dayE} />
        <Footer />
      </Wrapper>
    </>
  )
}

export default LuckyBag2023
const Wrapper = styled.div`
  /* padding-top: 70px; */
  position: relative;
  top: 0;
`
const NavbarWrapper = styled.div`
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
`
